/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form[_ngcontent-%COMP%]{margin:20px;padding:5px;background-color:#fff}select[_ngcontent-%COMP%]:required:invalid{color:gray}option[value=\"\"][disabled][_ngcontent-%COMP%]{display:none;color:gray}option[_ngcontent-%COMP%]{color:#000}hx-select[_ngcontent-%COMP%]{width:200px;border:1px solid gray}.form-title[_ngcontent-%COMP%]{padding:4px;font-size:80%;font-weight:700}"];
export { styles as styles };
